import { createContext } from "react";

import { BloombergEpisodesPageContextType } from "./types";
import { defaultBloombergEpisodesPageContextValue } from "./consts";

export const BloombergEpisodesPageContext = createContext<BloombergEpisodesPageContextType>(
  defaultBloombergEpisodesPageContextValue
);
